/**
 * Judge.me Carousel: força passo de scroll = 1 card + gap para mostrar
 * sempre 3 cards inteiros e alinhados.
 * do wrapper para que qualquer valor (incluindo autoplay) seja substituído pela posição correta.
 */
(function () {
  'use strict';

  var CAROUSEL_SELECTOR = '.shopify-app-block .jdgm-carousel.jdgm-carousel--compact-theme';
  var WRAPPER_SELECTOR = '.jdgm-carousel__item-wrapper';
  var ITEM_SELECTOR = '.jdgm-carousel-item';
  var LEFT_ARROW_SELECTOR = '.jdgm-carousel__left-arrow';
  var RIGHT_ARROW_SELECTOR = '.jdgm-carousel__right-arrow';

  function parseGapPx(gapStr) {
    if (!gapStr || gapStr === 'normal') return 0;
    var n = parseFloat(gapStr, 10);
    if (gapStr.indexOf('rem') !== -1) n *= 16;
    return n;
  }

  function getStepPx(carousel) {
    var wrapper = carousel.querySelector(WRAPPER_SELECTOR);
    var first = carousel.querySelector(ITEM_SELECTOR);
    if (!wrapper || !first) return { step: 364, gap: 24 };
    var gapStr = window.getComputedStyle(wrapper).gap;
    var gap = parseGapPx(gapStr);
    var cardWidth = first.offsetWidth || 340;
    return { step: cardWidth + gap, gap: gap };
  }

  function parseTranslateX(value) {
    if (!value || value === 'none') return 0;
    var m = value.match(/translate3d\((-?\d*\.?\d+)px/);
    if (m) return parseFloat(m[1], 10);
    m = value.match(/matrix\((-?\d*\.?\d+)/);
    return m ? parseFloat(m[1], 10) : 0;
  }

  function getTranslateX(wrapper) {
    var t = wrapper.style.transform || window.getComputedStyle(wrapper).transform;
    return parseTranslateX(t);
  }

  function setTranslateX(wrapper, x) {
    wrapper.style.transform = 'translate3d(' + x + 'px, 0, 0)';
  }

  function initCarousel(carousel) {
    var wrapper = carousel.querySelector(WRAPPER_SELECTOR);
    var leftArrow = carousel.querySelector(LEFT_ARROW_SELECTOR);
    var rightArrow = carousel.querySelector(RIGHT_ARROW_SELECTOR);
    if (!wrapper || !leftArrow || !rightArrow) return;

    var cards = carousel.querySelectorAll(ITEM_SELECTOR);
    var totalCards = cards.length;
    var currentIndex = 0;

    /* 
     * O Judge.me (incluindo autoplay) chama wrapper.style.transform = '...' ou setProperty.
     * Substituímos pelo valor "snapped" (múltiplo de step) para manter 3 cards alinhados. */
    function snapTransform(value) {
      var s = getStepPx(carousel);
      if (s.step <= 0) return value;
      var x = typeof value === 'string' ? parseTranslateX(value) : value;
      var maxIndex = Math.max(0, totalCards - 3);
      var index = Math.round(-x / s.step);
      index = Math.max(0, Math.min(maxIndex, index));
      currentIndex = index;
      return 'translate3d(' + (-index * s.step) + 'px, 0, 0)';
    }

    var styleObj = wrapper.style;
    try {
      var nativeTransformDesc = Object.getOwnPropertyDescriptor(styleObj, 'transform') || (CSSStyleDeclaration && Object.getOwnPropertyDescriptor(CSSStyleDeclaration.prototype, 'transform'));
      if (nativeTransformDesc && nativeTransformDesc.set) {
        var nativeSet = nativeTransformDesc.set;
        Object.defineProperty(styleObj, 'transform', {
          set: function (v) {
            nativeSet.call(styleObj, snapTransform(v));
          },
          get: nativeTransformDesc.get,
          configurable: true,
          enumerable: true
        });
      }
    } catch (e) { /* fallback: só o setInterval abaixo corrige */ }

    try {
      var nativeSetProperty = styleObj.setProperty.bind(styleObj);
      styleObj.setProperty = function (name, value, priority) {
        if (name === 'transform' && value) {
          value = snapTransform(value);
        }
        return nativeSetProperty(name, value, priority);
      };
    } catch (e) { /* fallback */ }

    function updateTransform() {
      var s = getStepPx(carousel);
      var maxIndex = Math.max(0, totalCards - 3);
      currentIndex = Math.max(0, Math.min(maxIndex, currentIndex));
      setTranslateX(wrapper, -currentIndex * s.step);
    }

    function goPrev(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      currentIndex = Math.max(0, currentIndex - 1);
      updateTransform();
    }

    function goNext(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var maxIndex = Math.max(0, totalCards - 3);
      currentIndex = Math.min(maxIndex, currentIndex + 1);
      updateTransform();
    }

    function syncFromTransform() {
      var s = getStepPx(carousel);
      var x = getTranslateX(wrapper);
      if (s.step <= 0) return;
      var maxIndex = Math.max(0, totalCards - 3);
      var index = Math.round(-x / s.step);
      index = Math.max(0, Math.min(maxIndex, index));
      currentIndex = index;
      setTranslateX(wrapper, -index * s.step);
    }

    leftArrow.addEventListener('click', goPrev, true);
    rightArrow.addEventListener('click', goNext, true);

    leftArrow.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goPrev(e);
      }
    }, true);
    rightArrow.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        goNext(e);
      }
    }, true);

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        var s = getStepPx(carousel);
        currentIndex = Math.max(0, Math.min(Math.max(0, totalCards - 3), currentIndex));
        styleObj.transform = 'translate3d(' + (-currentIndex * s.step) + 'px, 0, 0)';
      }, 150);
    });

    /* Snap periódico: cobre o caso de o app setar transform por outro caminho */
    setInterval(syncFromTransform, 150);

    setTimeout(syncFromTransform, 100);
    setTimeout(syncFromTransform, 600);
  }

  function run() {
    var carousels = document.querySelectorAll(CAROUSEL_SELECTOR);
    carousels.forEach(function (el) {
      if (el.getAttribute('data-jdgm-carousel-fix') === 'done') return;
      el.setAttribute('data-jdgm-carousel-fix', 'done');
      initCarousel(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  setTimeout(run, 800);
  var observer = new MutationObserver(function () {
    run();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
